import React from "react";
import "./styles.scss";

const Button = ({ children, onClick, light, className }) => {

  var themeClass = light ? "light-button" : "dark-button";

  return (
    <button onClick={onClick} className={`${className} styled-button ${themeClass}`}>
      {children}
    </button>
  );
};

export default Button;